import CommonApp from '../../app.js';

CommonApp.module.directive('nsRemoveEmailValidation', function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$validators['email'] = function() {
                return true;
            };
        }
    };
});




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/remove-email-validation/remove-email-validation.js
// module id = 271
// module chunks = 0